<template>
  <div id="smartTown" class="product-page">
    <!-- 标题区域 -->
    <h1 class="page-title">电子死亡证明管理系统</h1>

    <!-- 正文内容区域 -->
    <div class="page-content">
      <!-- 第1章 产品概述 -->
      <div class="text-section">
        <h2 class="chapter-title">一、产品概述</h2>
        <p class="content-paragraph">
          电子死亡证明管理系统以打造针对死亡人口证件服务平台为目标，以数据融合、共享与互认为技术手段，打通跨单位的信息壁垒，让数据多跑路、群众少跑腿，有效缓解死者家属在领取丧葬补贴费和注销户口时遇到的堵点问题。
        </p>
        <p class="content-paragraph">
          通过死亡人口信息资源的充分融合，构建省级死亡人口信息数据中心，强化省级人口动态数据收集分析和人口监测预警，同时强化以人民为中心的思想，进一步完善人口公共服务体系，推动人口信息管理的创新与政府职能的转变。系统涵盖省级居民死亡医学证明（推断）书管理、村（居）委会死亡情况证明管理、公安部门死亡情况核查管理、公安司法部门死亡证明管理四大子系统，实现死亡信息从签发、流转、核查到注销的全流程闭环管理。
        </p>

        <!-- 核心能力 -->
        <div class="capability-grid">
          <div class="capability-card">
            <h3 class="capability-title">医学证明签发</h3>
            <ul class="capability-list"><li>死亡信息录入</li><li>死亡调查信息</li><li>死亡证明审核</li><li>电子证件签发</li><li>无名遗体登记</li><li>历史信息补录</li><li>编码管理</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">基层发证与流转</h3>
            <ul class="capability-list"><li>村居死亡登记</li><li>申请受理发证</li><li>信息自动流转</li><li>外地死亡登记</li><li>电子身份认证</li><li>电子印章管理</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">公安核查与司法</h3>
            <ul class="capability-list"><li>核查受理管理</li><li>上门核查信息</li><li>核查结果审批</li><li>核查结果流转</li><li>非正常死亡录入</li><li>非正常死亡审核</li><li>移动应用端</li></ul>
          </div>
        </div>
      </div>

      <!-- 第2章 产品截图 -->
      <div class="text-section">
        <h2 class="chapter-title">二、产品截图</h2>
        <p class="shot-note">以下为系统功能示意，实际界面以项目交付成果为准。</p>
        <div class="shot-grid">
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/sw-dashboard.svg"
              alt="海南华德科技有限公司 电子死亡证明管理系统 - 省级死亡人口数据中心 · 多部门协同"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">01</span>省级死亡人口数据中心 · 多部门协同
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/sw-issue.svg"
              alt="海南华德科技有限公司 电子死亡证明管理系统 - 死亡医学证明 · 签发与电子证件管理"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">02</span>死亡医学证明 · 签发与电子证件管理
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/sw-village.svg"
              alt="海南华德科技有限公司 电子死亡证明管理系统 - 基层移动端 · 村居登记与上门核查"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">03</span>基层移动端 · 村居登记与上门核查
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/sw-audit.svg"
              alt="海南华德科技有限公司 电子死亡证明管理系统 - 核查管理与系统管理"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">04</span>核查管理与系统管理
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
};
</script>
<style scoped>
/* 全局容器样式 */
.product-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: "Poppins", "Microsoft YaHei", "PingFang SC", sans-serif;
  background-color: var(--light-bg);
  min-height: 100vh;
}

/* 标题样式 */
.page-title {
  font-weight: 700;
  font-size: 32px;
  color: var(--text-color);
  text-align: center;
  margin: 0 auto 50px;
  padding-bottom: 15px;
  border-bottom: 3px solid var(--primary-color1);
  display: inline-block;
  width: 100%;
  letter-spacing: 1px;
}

/* 内容容器 */
.page-content {
  background-color: var(--white);
  padding: 50px 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* 章节区域 */
.text-section {
  margin: 20px 0 60px;
}
.text-section:last-child {
  margin-bottom: 20px;
}

/* 章节标题 */
.chapter-title {
  font-weight: 700;
  font-size: 20px;
  color: var(--text-color);
  margin: 10px 0 25px;
  padding-left: 10px;
  border-left: 4px solid var(--primary-color1);
  line-height: 1.4;
}

/* 正文段落 */
.content-paragraph {
  line-height: 1.8;
  font-weight: 400;
  color: var(--text-color2);
  margin: 8px 0 22px;
  text-indent: 2em;
  font-size: 16px;
  text-align: justify;
}
.content-paragraph strong {
  color: var(--primary-color1);
  font-weight: 600;
}

/* 核心能力卡片 */
.capability-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 30px;
}
.capability-card {
  background-color: var(--light-bg);
  border-radius: 10px;
  padding: 22px 20px;
  border-top: 3px solid var(--primary-color1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.capability-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}
.capability-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-color);
  margin: 0 0 14px;
}
.capability-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.capability-list li {
  display: inline-block;
  background-color: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 4px 12px;
  margin: 0 6px 8px 0;
  font-size: 13px;
  color: var(--text-color2);
  transition: all 0.3s ease;
}
.capability-list li:hover {
  border-color: rgba(230, 0, 76, 0.35);
  color: var(--primary-color1);
}

/* 产品截图 */
.shot-note {
  font-size: 13px;
  color: var(--text-color3);
  margin: -10px 0 22px;
}
.shot-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}
.shot-card {
  margin: 0;
  background: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}
.shot-card:hover {
  transform: translateY(-4px);
  border-color: rgba(230, 0, 76, 0.25);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06), 0 10px 28px rgba(0, 0, 0, 0.08);
}
.shot-card img {
  display: block;
  width: 100%;
  height: auto;
}
.shot-card figcaption {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  font-size: 14px;
  color: var(--text-color);
  border-top: 1px solid #f2f2f2;
  background: var(--white);
}
.shot-index {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 700;
  color: var(--primary-color1);
  background: rgba(230, 0, 76, 0.08);
  border-radius: 4px;
  padding: 2px 7px;
}

/* 响应式 */
@media (max-width: 991px) {
  .capability-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  .product-page {
    padding: 24px 14px;
  }
  .page-title {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .page-content {
    padding: 28px 18px;
  }
  .capability-grid,
  .shot-grid {
    grid-template-columns: 1fr;
  }
  .content-paragraph {
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/softwareWs3.vue